<template>
  <aside :class="{'closed':sidebarClosed}" v-if="user != null">
    <header :class="{ 'opened': headerOpened || $route.path.indexOf(getPersonalInfoRoute()) > -1 || $route.path.indexOf('/informacoes-pessoais') > -1 || $route.path.indexOf('/minha-assinatura') > -1 }">
      <div class="userInfo" @click="toggleHeader">
        <img :src="logo" width="40" height="40" :alt="user.person.client.name" />
        <p class="userData">{{ user.person.client.name }} <br/><span class="user">{{ user.name }}</span></p>
        <div class="clearfix"></div>
      </div>

      <button class="closeBtn" @click="toggleSidebar">
        <i class="far fa-angle-left"></i>
      </button>

      <div class="clearfix"></div>

      <ul class="headerDropdown">
        <router-link tag="li" :class="{ 'active': $route.path.indexOf('/informacoes-pessoais') > -1}" to="/informacoes-pessoais" class="item"><i class="far fa-user-circle" v-tooltip="(sidebarClosed)?'Informações Pessoais':''"></i> Informações Pessoais</router-link>
        <router-link tag="li" v-if="helpers.checkPermission('subscription', 'can_see')" :class="{ 'active': $route.path.indexOf('/minha-assinatura') > -1}" to="/minha-assinatura" class="item"><i class="far fa-file-invoice" v-tooltip="(sidebarClosed)?'Minha Assinatura':''"></i> Minha Assinatura</router-link>
        <li class="item" @click="logout"><i class="far fa-sign-out" v-tooltip="(sidebarClosed)?'Sair':''"></i> Sair</li>
      </ul>

      <div class="clearfix"></div>
    </header>

    <div class="attendance" v-if="!isSuspended && attendance != null">
      <p class="title">Atendimento em andamento</p>

      <p class="patient mb-0">Paciente: <b>{{ attendance.patient.name }}</b></p>
      <p class="time">{{ timer }}</p>

      <router-link :to="'/pacientes/'+attendance.patient.id" class="btn btn-light btn-block btn-sm">Ir para o paciente</router-link>
    </div>

    <div class="box">
<!--      <p class="title">{{(sidebarClosed)?'PRO':'PROFISSIONAL'}}</p>-->

      <ul>
        <router-link tag="li" v-if="!isSuspended" :class="{ 'active': $route.path.indexOf('/dashboard') > -1}" to="/dashboard" class="item"><i class="far fa-home" v-tooltip="(sidebarClosed)?'Dashboard':''"></i> Dashboard</router-link>

        <router-link class="has-dropdown" v-if="!isSuspended" tag="li" to="/" :class="{ 'opened active': ($route.path == '/' || $route.path.indexOf('/confirmacoes') > -1) }">
          <span class="item"><i class="far fa-calendar" v-tooltip="(sidebarClosed)?'Agendas':''"></i> Agendas</span>
          <ul class="dropdown">
            <router-link tag="li" exact-active-class="active" to="/" class="item"><i class="far fa-clock" v-tooltip="(sidebarClosed)?'Horários':''"></i> Horários</router-link>
            <router-link tag="li" v-if="helpers.checkPermission('agendas', 'can_see')" :class="{ 'active': $route.path.indexOf('/confirmacoes') > -1}" to="/confirmacoes" class="item"><i class="fab fa-whatsapp" v-tooltip="(sidebarClosed)?'Confirmações':''"></i> Confirmações</router-link>
          </ul>
        </router-link>

        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('patients', 'can_see')" :class="{ 'active': $route.path.indexOf('/pacientes') > -1}" to="/pacientes" class="item"><i class="far fa-users" v-tooltip="(sidebarClosed)?'Pacientes':''"></i> Pacientes</router-link>
        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('professionals', 'can_see')" :class="{ 'active': $route.path.indexOf('/profissionais') > -1}" to="/profissionais" class="item"><i class="far fa-user-md" v-tooltip="(sidebarClosed)?'Profissionais':''"></i> Profissionais</router-link>
        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('secretaries', 'can_see')" :class="{ 'active': $route.path.indexOf('/secretarias') > -1}" to="/secretarias" class="item"><i class="far fa-user" v-tooltip="(sidebarClosed)?'Secretárias':''"></i> Secretárias</router-link>
        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('coordinators', 'can_see') && user.person.client.enable_coordinator_profile" :class="{ 'active': $route.path.indexOf('/coordenadores') > -1}" to="/coordenadores" class="item"><i class="far fa-user-cog" v-tooltip="(sidebarClosed)?'Coordenadores':''"></i> Coordenadores</router-link>

        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('forms', 'can_see')" :class="{ 'active': $route.path.indexOf('/prontuarios') > -1}" to="/prontuarios" class="item"><i class="far fa-notes-medical" v-tooltip="(sidebarClosed)?'Prontuários':''"></i> Prontuários</router-link>

        <router-link tag="li" v-if="!isSuspended && (helpers.isOwner() || user.person.type == 'SECRETARY' || helpers.checkPermission('attendance-guides', 'can_see', true))" :class="{ 'active': $route.path.indexOf('/guias-de-atendimento') > -1}" to="/guias-de-atendimento" class="item"><i class="fas fa-clipboard-list" v-tooltip="(sidebarClosed)?'Guias de Atendimento':''"></i> Guias de Atendimento</router-link>

        <li class="has-dropdown" v-if="!isSuspended && (helpers.checkPermission('incomes', 'can_see', true) || helpers.checkPermission('expenses', 'can_see', true) || helpers.checkPermission('cash-flow', 'can_see', true) || (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('units', 'can_see')))" :class="{ 'opened active': (financialOpened || $route.path.indexOf('/financeiro') > -1) }">
          <span class="item" @click="financialOpened = !financialOpened"><i class="far fa-file-invoice-dollar" v-tooltip="(sidebarClosed)?'Financeiro':''"></i> Financeiro</span>
          <ul class="dropdown">
            <template v-if="helpers.planHasPermission('financial')">
              <router-link tag="li" v-if="helpers.checkPermission('incomes', 'can_see', true)" :class="{ 'active': $route.path.indexOf('/financeiro/contas-a-receber') > -1}" to="/financeiro/contas-a-receber" class="item"><i class="far fa-receipt" v-tooltip="(sidebarClosed)?'Contas a Receber':''"></i> Contas a Receber</router-link>
              <router-link tag="li" v-if="helpers.checkPermission('expenses', 'can_see', true)" :class="{ 'active': $route.path.indexOf('/financeiro/contas-a-pagar') > -1}" to="/financeiro/contas-a-pagar" class="item"><i class="far fa-file-invoice" v-tooltip="(sidebarClosed)?'Contas a Pagar':''"></i> Contas a Pagar</router-link>
              <router-link tag="li" v-if="helpers.checkPermission('cash-flow', 'can_see', true)" :class="{ 'active': $route.path.indexOf('/financeiro/fluxo-de-caixa') > -1}" to="/financeiro/fluxo-de-caixa" class="item"><i class="far fa-cash-register" v-tooltip="(sidebarClosed)?'Fluxo de Caixa':''"></i> Fluxo de Caixa</router-link>
            </template>
            <template v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('units', 'can_see')">
              <router-link tag="li" :class="{ 'active': $route.path.indexOf('/financeiro/transacoes') > -1 && $route.path.indexOf('/financeiro/transacoes-extrato') === -1}" to="/financeiro/transacoes" class="item"><i class="far fa-money-check-alt" v-tooltip="(sidebarClosed)?'Transações':''"></i> Transações</router-link>
              <router-link tag="li" :class="{ 'active': $route.path.indexOf('/financeiro/transacoes-extrato') > -1}" to="/financeiro/transacoes-extrato" class="item"><i class="far fa-file-invoice-dollar" v-tooltip="(sidebarClosed)?'Transações - Extrato':''"></i> Transações - Extrato</router-link>
            </template>
          </ul>
        </li>

<!--        <li class="has-dropdown" v-if="!isSuspended && (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('sellers', 'can_see'))" :class="{ 'opened active': (paymentsOpened || $route.path.indexOf('/cobrancas') > -1) }">-->
<!--          <span class="item" @click="paymentsOpened = !paymentsOpened"><i class="far fa-money-check-alt" v-tooltip="(sidebarClosed)?'Cobranças':''"></i> Cobranças</span>-->
<!--          <ul class="dropdown">-->

<!--            <router-link tag="li" v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('sellers', 'can_see')" :class="{ 'active': $route.path.indexOf('/cobrancas/contas-de-cobranca') > -1}" to="/cobrancas/contas-de-cobranca" class="item"><i class="far fa-university" v-tooltip="(sidebarClosed)?'Contas de Cobrança':''"></i> Contas de Cobrança</router-link>-->
<!--          </ul>-->
<!--        </li>-->

        <router-link tag="li" v-if="!isSuspended && helpers.checkPermission('dashboard', 'can_see')" :class="{ 'active': $route.path.indexOf('/painel-de-controle') > -1}" to="/painel-de-controle" class="item"><i class="far fa-chart-bar" v-tooltip="(sidebarClosed)?'Painel de Controle':''"></i> Painel de Controle</router-link>


        <li class="has-dropdown" v-if="!isSuspended && (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('agendas', 'can_see') || helpers.checkPermission('client-data', 'can_see') || helpers.checkPermission('whatsapps', 'can_see') || helpers.checkPermission('health-plans', 'can_see') || helpers.checkPermission('procedures', 'can_see'))" :class="{ 'opened active': (settingsOpened || $route.path.indexOf('/configuracoes') > -1) }">
          <span class="item" @click="settingsOpened = !settingsOpened"><i class="far fa-cogs" v-tooltip="(sidebarClosed)?'Configurações':''"></i> Configurações</span>
          <ul class="dropdown">
            <router-link tag="li" v-if="helpers.checkPermission('agendas', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/agendas') > -1}" to="/configuracoes/agendas" class="item"><i class="far fa-calendar-alt" v-tooltip="(sidebarClosed)?'Agendas':''"></i> Agendas</router-link>

            <router-link tag="li" v-if="helpers.checkPermission('client-data', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/cartao-digital') > -1}" to="/configuracoes/cartao-digital" class="item"><i class="far fa-address-card" v-tooltip="(sidebarClosed)?'Cartão Digital':''"></i> Cartão Digital</router-link>
            <router-link tag="li" v-if="helpers.checkPermission('client-data', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/configuracoes-gerais') > -1}" to="/configuracoes/configuracoes-gerais" class="item"><i class="far fa-cog" v-tooltip="(sidebarClosed)?'Configurações Gerais':''"></i> Configurações Gerais</router-link>
            <router-link tag="li" v-if="helpers.checkPermission('agendas', 'can_see') && (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('whatsapps', 'can_see'))" :class="{ 'active': $route.path.indexOf('/configuracoes/contas-de-whatsapp') > -1}" to="/configuracoes/contas-de-whatsapp" class="item"><i class="fab fa-whatsapp" v-tooltip="(sidebarClosed)?'Contas de Whatsapp':''"></i> Contas de Whatsapp</router-link>

            <router-link tag="li" v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || helpers.checkPermission('health-plans', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/convenios') > -1}" to="/configuracoes/convenios" class="item"><i class="fas fa-medkit" v-tooltip="(sidebarClosed)?'Convênios':''"></i> Convênios</router-link>
            <router-link tag="li" v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || helpers.checkPermission('procedures', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/procedimentos') > -1}" to="/configuracoes/procedimentos" class="item"><i class="far fa-file-medical" v-tooltip="(sidebarClosed)?'Procedimentos':''"></i> Procedimentos</router-link>

            <router-link tag="li" v-if="user.person.client.directing_enabled && helpers.checkPermission('directing-sectors', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/setores') > -1}" to="/configuracoes/setores" class="item"><i class="fas fa-map-marker-alt" v-tooltip="(sidebarClosed)?'Setores':''"></i> Setores</router-link>

            <router-link tag="li" v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR' || helpers.checkPermission('units', 'can_see')" :class="{ 'active': $route.path.indexOf('/configuracoes/unidades') > -1}" to="/configuracoes/unidades" class="item"><i class="far fa-hospital" v-tooltip="(sidebarClosed)?'Unidades':''"></i> Unidades</router-link>
          </ul>
        </li>

        <li class="item" v-if="user.person.client.affiliate_account != null" @click="$bvModal.show('share-modal')"><i class="far fa-share-alt" v-tooltip="(sidebarClosed)?'Indique e ganhe!':''"></i> Indique e ganhe!</li>

        <li @click="goToHelp()" class="item help"><i class="fal fa-question-circle" v-tooltip="(sidebarClosed)?'Central de Ajuda':''"></i> Central de Ajuda</li>
      </ul>
    </div>

    <p class="logo">
      <img src="@/assets/images/consulta-ja-logo.svg" width="50%" alt="Consulta Já" class="mb-0" /><br/>
      <small>{{ version }}</small>
    </p>


    <b-modal id="share-modal" class="share-modal" :modalClass="'share-modal'" @hidden="shareName = null; shareEmail = null;">
      <template slot="modal-header">
        <div>
          <div class="h4 font-weight-normal">Indique e ganhe!</div>
          <div class="mt-3">Indique o Consulta Já e ganhe 100% de desconto* na sua próxima mensalidade!</div>
        </div>
      </template>
      <template slot="default">
        <validation-observer ref="shareForm" v-slot="{ invalid }">
          <b-row>
            <b-col cols="12" class="text-center mb-3">{{getShareUrl()}}</b-col>
            <b-col cols="12" class="text-center mb-3">
              <b-form-textarea class="copyShareUrlTextArea" :value="getShareUrl()" ref="shareUrl"></b-form-textarea>
              <b-button variant="primary" @click="copyShareUrl">Copiar</b-button>
            </b-col>
            <b-col cols="12" class="text-center">
              <div class="section-divider">
                <span>Compartilhe no Whatsapp</span>
              </div>
            </b-col>
            <b-col cols="12" class="text-center mb-3">
              <b-button variant="success" @click="shareWithWhatsapp"><i class="fab fa-whatsapp"></i> Whatsapp</b-button>
            </b-col>
            <b-col cols="12" class="text-center">
              <div class="section-divider">
                <span>Convide por e-mail</span>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <label class="cj-label">Nome</label>
              <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                <b-form-input type="text" v-model="shareName" :class="{ 'error': errors.length > 0 }"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="6">
              <label class="cj-label">E-mail</label>
              <validation-provider name="e-mail" :rules="{ required: true, email: true }" v-slot="{ errors }">
                <b-form-input type="email" v-model="shareEmail" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="text-center mt-3">
              <b-button variant="primary" @click="shareWithEmail">Enviar</b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <div class="share-notes">*Confira o regulamento do programa de afiliados aqui! <a :href="affiliateProgramUrl" target="_blank">{{affiliateProgramUrl}}</a></div>
      </template>
    </b-modal>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      sidebarClosed: false,
      headerOpened: false,
      financialOpened: false,
      paymentsOpened: false,
      settingsOpened: false,
      userNameInitials: '',
      logo: '',

      attendance: null,
      interval: null,
      timer: null,

      shareName: null,
      shareEmail: null,
      affiliateProgramUrl: 'https://consultaj.tawk.help/article/programa-de-indicacao',

      user: JSON.parse(localStorage.getItem('user')),
      isSuspended: false,
      version: process.env.VUE_APP_VERSION
    }
  },
  watch: {
    '$route' () {
      if(this.$attrs['isMobile'] && this.sidebarClosed) {
        this.toggleSidebar();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.user = JSON.parse(localStorage.getItem('user'));
      this.isSuspended = this.api.isSuspended();
      this.version = localStorage.getItem('version');

      let userData = this.user;
      this.sentry.configureScope(function(scope) {
        scope.setUser({
          'id': userData.person.id,
          'email': userData.person.email,
          'Name': userData.person.name,
          'Client ID': userData.person.client.id,
          'Client Name': userData.person.client.name
        });
      });

      if(process.env.VUE_APP_ENVIRONMENT == 'production') {
        this.$ma.setUserProperties({
          userId: userData.person.id,
          name: userData.person.name,
          email: userData.person.email
        });
      }
      this.logo = this.user.person.client.logo ? this.user.person.client.logo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);

      this.eventBus.$on('CLIENT_LOGO_CHANGED', (logo) => {
        this.logo = logo ? logo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);
        let user = JSON.parse(localStorage.getItem('user'));
        user.person.client.logo = logo;
        localStorage.setItem('user', JSON.stringify(user));
      });

      this.eventBus.$on('CLIENT_STATUS_CHANGED', () => {
        this.isSuspended = this.api.isSuspended();
      });

      this.eventBus.$on('ATTENDANCE_STARTED', (attendance) => {
        localStorage.setItem('attendance', JSON.stringify(attendance));
        this.checkAttendance();
      });

      this.eventBus.$on('ATTENDANCE_ENDED', () => {
        localStorage.removeItem('attendance');
        this.checkAttendance();
      });
    }, 500);
  },
  methods: {
    toggleSidebar() {
      this.sidebarClosed = !this.sidebarClosed;
    },
    toggleHeader() {
      this.headerOpened = !this.headerOpened;
      if(this.$attrs['isMobile']) {
        this.sidebarClosed = true;
      }
    },
    logout() {
      this.$swal({
        title: 'Você tem certeza de que deseja sair?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sair',
        cancelButtonText: 'Cancelar',
        focusCancel: true
      }).then((res) => {
        if(res.value) {
          localStorage.clear();

          this.$Tawk.$endChat();
          this.eventBus.$emit('IS_LOGGED', false);
          this.$router.push('/login').catch(() => {});
        }
      })
    },
    getPersonalInfoRoute() {
      let route = '/';
      switch (this.user.person.type) {
        case 'PROFESSIONAL':
          route += 'profissionais/';
        break;
        case 'SECRETARY':
          route += 'secretarias/';
        break;
        case 'COORDINATOR':
          route += 'coordenadores/';
        break;
        default:
          route += 'pacientes/';
        break;
      }
      route += this.user.person.id;
      return route;
    },
    goToHelp() {
      window.open('https://consultaj.tawk.help');
    },
    checkAttendance() {
      this.attendance = JSON.parse(localStorage.getItem('attendance'));
      if(this.attendance) {
        this.interval = setInterval(this.setTimer, 1000);
      } else {
        this.timer = null;
        if(this.interval != null)
          clearInterval(this.interval);
      }
    },
    setTimer() {
      let now = this.moment();
      let diff = now.diff(this.moment(this.attendance.start_datetime), 'seconds');

      this.timer = this.moment.duration(diff, 'seconds').format('hh:mm:ss', { trim: false });
    },
    getShareUrl() {
      return 'https://consultaja.com/' + this.user.person.client.affiliate_account.slug;
    },
    shareWithWhatsapp() {
      let text = this.user.name + ' quer te indicar o Consulta Já para otimizar e melhorar os resultados da sua clínica e acaba de te enviar um desconto* de 50% em uma mensalidade!\n\nAcesse: ' + this.getShareUrl() + '\n\n*Confira o regulamento do programa de indicação aqui! ' + this.affiliateProgramUrl;
      window.open('https://wa.me?text='+encodeURIComponent(text));
    },
    copyShareUrl() {
      this.$refs.shareUrl.select();
      document.execCommand('copy');
      this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
    },
    async shareWithEmail() {
      const isValid = await this.$refs.shareForm.validate();
      if(!isValid) {
        return false;
      }
      this.api.shareWithEmail({name:this.shareName, email:this.shareEmail}).then(res => {
        this.$swal('Uhull \\o/', 'Convite enviado com sucesso!', 'success');

        this.$bvModal.hide('share-modal');

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Share With Email', res);
      }).catch(err => {
        this.canPerformAction = true;

        let msg = 'Não conseguimos enviar o convite! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        switch (err.response.status) {
          case 400:
            msg = err.response.data.message;
            break;
          case 422:
            msg = err.response.data.errors.join('\r\n');
            break;
        }

        this.$swal('Ops...', msg, 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Share With Email', err.response);
      });
    }
  }
}
</script>

<style scoped lang="scss">
  aside {
    font-family: 'sf_pro_displaymedium';
    width: 240px;
    background-color: $bunting;
    overflow: hidden;
    transition: all 0.5s;
    display: flex;
    flex-flow: column wrap;
    font-size: 15px;

    * {
      transition: all 0.5s;
    }

    header {
      background-color: $tangaroa;
      position: relative;
      overflow: hidden;
      max-height: 88px;
      height: 88px;
      flex: 1;
      width: 100%;

      .userInfo {
        width: 100%;
        padding: 20px 12px;
        cursor: pointer;
        display: inline-block;

        * {
          cursor: pointer;
        }

        img {
          border: 2px solid $blueBayoux;
          border-radius: 5px;
          float: left;
        }

        .userData {
          width: 162px;
          color: $athenGray2;
          font-family: 'sf_pro_displaybold';
          margin: 0 0 0 8px;
          line-height: 20px;
          float: left;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .user {
            font-weight: 300;
            color: $cadetGray;
            font-size: 14px;
          }
        }
      }

      .closeBtn {
        height: 40px;
        background-color: $waikawaGray;
        border: 0;
        border-radius: 5px 0 0 5px;
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 25px;
        transition: all 0.5s;

        i {
          font-size: 17px;
          color: $linkWater;
          vertical-align: middle;
          transition: all 0.5s;
          cursor: pointer;
        }
      }

      .headerDropdown {
        width: 100%;
        max-height: 0;

        .item.active {
          border-color: transparent;
        }
      }

      ul {
        margin: 0;
      }

      &.opened {
        max-height: 222px;
        padding-bottom: 15px;

        .headerDropdown {
          max-height: 222px;
        }
      }
    }

    .item {
      width: 100%;
      padding: 8px 12px;
      display: flex;
      align-items: center;
      color: $cadetGray;
      border-left: 4px solid transparent;
      cursor: pointer;

      &.help {
        margin-top: 25px;
      }

      i {
        width: 20px;
        text-align: center;
        font-size: 20px;
        margin-right: 14px;
      }

      &.active {
        color: $athenGray2;
        font-family: 'sf_pro_displaybold';

        i {
          color: #24A7F0;
        }
      }

      &:hover {
        color: $athenGray2;
        font-family: 'sf_pro_displaybold';

        i {
          color: #24A7F0;
        }
      }
    }

    .attendance {
      width: 100%;
      max-height: 200px;
      padding: 15px;
      background-color: $supernova;
      text-align: center;
      overflow: hidden;

      .title {
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: bold;
        color: $tangaroa;
      }

      .time {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 15px;
      }
    }

    .box {
      width: 100%;
      flex: 1;
      margin-top: 15px;

      .title {
        margin: 5px 25px 5px 25px;
        font-size: 12px;
        font-weight: bold;
        color: $waikawaGray;
      }

      .has-dropdown {
        overflow: hidden;
        display: flex;
        flex-flow: row wrap;
        border-left: 4px solid transparent;

        .item {
          border: 0;
        }

        > .item:first-child {
          position: relative;

          &:before {
            width: 12px;
            height: 12px;
            font-family: 'Font Awesome 5 Pro';
            font-weight: 400;
            content: '\f107';
            position: absolute;
            right: 25px;
            top: 50%;
            transform: translateY(-50%);
            transition: all 0.5s;
          }
        }

        .dropdown {
          max-height: 0;
          width: 100%;
        }

        &.opened {
          margin: 5px 0;
          padding: 5px 0;
          background-color: $tangaroa;
          border-left: 4px solid $pictionBlue;

          > .item:first-child {
            color: $athenGray2;
            font-family: 'sf_pro_displaybold';

            i {
              color: $pictionBlue;
            }

            &:before {
              transform: scaleY(-1);
            }
          }

          .dropdown {
            max-height: 310px;
          }
        }
      }
    }

    .logo {
      text-align: right;
      margin: 25px 15px;
      align-self: flex-end;
      position: relative;

      small {
        font-size: 50%;
        line-height: 0.5;
        color: $whisper;
        position: absolute;
        top: 2px;
        right: 20px;
        text-align: left;
      }
    }

    &.closed {
      width: 88px;

      header {
        .userInfo {
          padding: 20px 25px;

          .userData {
            display: none;
          }
        }
        .closeBtn {
          i {
            transform: scaleX(-1);
          }
        }
      }

      .item {
        justify-content: center;
        font-size: 0;

        i {
          width: 40px;
          margin-right: 0;
        }
      }

      .attendance {
        max-height: 0;
        padding: 0;
      }

      .box {
        .title {
          width: 40px;
          text-align: center;
        }
      }

      .logo {
        transform: scaleX(0);
      }
    }
  }

  @media (max-width: 767px) {
    aside {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      min-height: 86px;
      max-height: 86px;
      z-index: 100;
      overflow: hidden;

      header {
        max-height: 80px;
        height: 80px;
        flex: 0;

        .userInfo {
          width: 100%;

          //.userData {
          //  width: 162px;
          //}
        }
      }

      .item {
        width: 100%;
      }

      .closeBtn {
        i {
          transform: rotate(-90deg);
        }
      }



      //.item {
      //  justify-content: center;
      //  font-size: 0;
      //
      //  i {
      //    width: 40px;
      //    margin-right: 0;
      //  }
      //}

      &.closed {
        width: 100%;
        min-height: 100vh;
        max-height: 100vh;
        display: -webkit-box;
        flex-flow: column;

        header {
          .userInfo {
            padding: 20px 12px;

            .userData {
              display: block;
            }
          }

          .closeBtn {
            i {
              transform: rotate(90deg);
            }
          }

          &.opened {
            max-height: none;
            height: auto;

            .headerDropdown {
              max-height: none;
              width: 100%;
            }
          }
        }

        .item {
          font-size: inherit;
          justify-content: normal;

          i {
            width: 20px;
            margin-right: 15px;
          }
        }

        .box {
          overflow: hidden;
          overflow-y: scroll;

          .title {
            width: auto;
            text-align: left;
          }
        }

        .logo {
          transform: scaleX(1);

          img {
            max-width: 120px;
          }
        }

      }
    }
  }
  #share-modal {
    .share-notes {
      font-style: italic;
      font-size: 12px;
      flex-grow: 1;
    }

    .copyShareUrlTextArea {
      width: 1px;
      height: 1px;
      padding: 0;
      opacity: 0;
    }

    .section-divider {
      border-top: 1px solid #DDD;
      text-align: center;
      margin-top: 15px;

      span {
        display: inline-block;
        position: relative;
        padding: 0 17px;
        background: #fff;
        color: $cadetGray;
        top: -13px;
        font-size: 15px;
      }
    }
  }
</style>
